import { ActionCardProps } from 'types/TextAnalysis'

interface WrapperProps {
  id: string
  index?: any
  elevation?: number
  anchorelmap?: any
  $hovered?: boolean
  $checked?: boolean
  onFocus?: () => void
  onBlur?: () => void
  onMouseLeave?: () => void
  $focused?: boolean
  sx?: { [key: string]: any }
  additionalProps?: any
}

export const generateCardProps = ({
  id,
  index,
  elevate,
  anchorElMap,
  hover,
  showCheckbox,
  $checked,
  showAddTag,
  cardMeta,
  cardActions,
  cardTitle,
  cardTitleLink,
  cardContent,
  cardMetricsVariant,
  cardMetrics,
  cardTags,
  cardTagMenu,
  $focused,
  onFocus,
  onBlur,
  onMouseLeave,
  handleCheckboxClick,
  handleIdeasCommentTitleClick,
  sx,
  additionalProps,
}: ActionCardProps) => {
  const wrapperProps: WrapperProps = {
    id: String(id),
    $checked,
    elevation: elevate || 0,
    index,
    anchorelmap: anchorElMap || {},
    $hovered: hover,
    $focused,
    onFocus,
    onBlur,
    onMouseLeave,
    sx: sx ? { ...sx } : undefined,
    additionalProps,
  }
  const headerProps = {
    id,
    hover,
    showCheckbox,
    $checked,
    showAddTag,
    cardMeta,
    cardActions,
    handleCheckboxClick,
  }
  const contentProps = {
    showCheckbox,
    cardTitle,
    cardTitleLink,
    cardContent,
    handleIdeasCommentTitleClick,
  }
  const footerProps = {
    showCheckbox,
    cardTags,
    cardMetrics,
    cardMetricsVariant,
  }

  return {
    wrapperProps,
    headerProps,
    contentProps,
    footerProps,
    cardTagMenu,
  }
}
